import React, { FC } from "react";

interface StatusLabelProps {
    value?: string | null;
    withStyle?: boolean;
    className?: string;
}

// Son los que encontre, por favor si se haya alguno o hay nuevos, agregarlo aqui tambien.
const STATUS_LABELS: Record<string, string> = {
    APPROVED: "Aprobado",
    DECLINED: "Rechazado",
    PENDING: "Pendiente",
    FAILED: "Rechazado",
    failed: "Rechazado",
    charge_pending: "Pendiente",
    CHARGE_PENDING: "Pendiente",
    EXPIRED: "Expirado",
    COMPLETED: "Completado",
    awaiting_withdrawal: "Pendiente",
    waiting: "No solicitado",
    LIQUIDADO: "Liquidado",
    CANCELADO: "Rechazado",
};

const STATUS_LABEL_STYLES: Record<string, string> = {
    APPROVED: "status",
    DECLINED: "status declined",
    PENDING: "status waiting",
    FAILED: "status failed",
    failed: "status failed",
    CHARGE_PENDING: "status waiting",
    charge_pending: "status waiting",
    EXPIRED: "status declined",
    COMPLETED: "status",
    awaiting_withdrawal: "status awaiting_withdrawal",
    waiting: "status waiting",
    LIQUIDADO: "status LIQUIDADO",
    CANCELADO: "status CANCELADO",
};

export const StatusLabel: FC<StatusLabelProps> = ({ value, withStyle = true, className }) => {
    const label = value ? STATUS_LABELS[value] ?? value : "";
    const baseClass = withStyle && value ? STATUS_LABEL_STYLES[value] ?? "status" : undefined;
    const Style = [baseClass, className].filter(Boolean).join(" ") || undefined;

    return <span className={Style}>{label}</span>;
    // El estatus siempre vendra con el withStyle en true, a menos que se indique lo contrario c:
};

export default StatusLabel;
